import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const Gyroscope = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('shoot_item3'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div className="bind-device-faq">
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('gyroscope_faq')}</span>
            </div>
            <span style={{ fontSize: 16, fontWeight: '500', color: '#000000', marginLeft: 25, marginTop: 15 }}>{t('gyroscope_faq_title')}</span>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px', whiteSpace: 'pre-line' }}>{t('gyroscope_faq_content')}</span>
            </div>
            <div className="bind-device-faq-marginH20">
                <img src={`${CommonUtil.getSourceDomain()}gyroscope.png`} alt="" style={{ width: '100%', marginLeft: 20, marginTop: 15 }} />
            </div>
            <div style={{ height: 40 }} />
        </div>
    </div>
}

export default Gyroscope